// Module
var code = "<div class=\"property-container\"></div> <span data-bind=\"text: Name\">Position</span> <select data-bind=\"options: $data._templates, enable: IsEnabled, optionsText: 'Name', value: $data._selectedTemplate, optionsCaption: 'Select...'\" class=\"form-control\"></select> ";
// Exports
export default code;